import { useEffect } from 'react'
import { Breadcrumbs } from '@/components/layout/breadcrumbs/breadcrumbs'
import { CompanyFreezeNotice } from '@/components/layout/company-freeze-notice'
import { ContextPanel } from '@/components/layout/context-panel'
import { ExpiredPaymentMethodNotice } from '@/components/layout/expired-payment-method-notice'
import { FraudSuspensionNotice } from '@/components/layout/fraud-suspension-notice'
import { OciMigrationNotice } from '@/components/layout/oci-migration-notice'
import { OtherSuspensionNotice } from '@/components/layout/other-suspension-notice'
import { PastDueInvoiceNotice } from '@/components/layout/past-due-invoice-notice'
import { PaymentSuspensionNotice } from '@/components/layout/payment-suspension-notice'
import { PrimarySidebar } from '@/components/layout/primary-sidebar'
import { ThemeSwitcher } from '@/components/layout/theme-switcher'
import { OnboardingSheet } from '@/components/onboarding-sheet'
import { GetStartedButton } from '@/components/onboarding-sheet/get-started-button'
import { SidebarTrigger } from '@/components/sv/sidebar'
import { useIdCompany, useRBAC } from '@/lib/hooks'

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { rbac } = useRBAC()
  const { idCompany } = useIdCompany()

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'j') {
        if (rbac.kinsta().superadmin.can()) {
          e.preventDefault()
          const path = idCompany
            ? `/superadmin/companies/${idCompany}`
            : '/superadmin'
          window.open(path, '_blank', 'noopener,noreferrer')
        }
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [rbac, idCompany])

  return (
    <div data-layout="root" className="flex w-full min-h-screen bg-sidebar">
      <PrimarySidebar />
      <ContextPanel />
      <main className="flex-1 min-w-0 flex flex-col bg-background">
        <header className="sticky z-20 top-0 bg-background flex items-center gap-2 px-4 h-[3.25rem] border-b border-border">
          <SidebarTrigger className="-ml-1" />
          <Breadcrumbs />
          <div className="ml-auto flex items-center gap-2">
            <PaymentSuspensionNotice />
            <OtherSuspensionNotice />
            <PastDueInvoiceNotice />
            <ExpiredPaymentMethodNotice />
            <FraudSuspensionNotice />
            <CompanyFreezeNotice />
            <OciMigrationNotice />
            <GetStartedButton />
            <ThemeSwitcher />
          </div>
        </header>
        <div className="flex-1 p-4">
          <div className="w-full max-w-[1280px] mx-auto">{children}</div>
        </div>
      </main>
      <OnboardingSheet />
    </div>
  )
}
